module.exports = __webpack_public_path__ + "img/91ab7a6.jpg";